/**
 * Patient Import Feature Types
 *
 * Re-exports generated types from the data-migration codegen with
 * user-friendly aliases, plus local constants for the import wizard.
 */

// =============================================================================
// Re-exported generated types (with aliases for local readability)
// =============================================================================

export type {
  ApproveImportResponse,
  ExtractedPatientReviewItem as ExtractedPatient,
  ExtractionReviewResponse as ExtractedPatientsResponse,
  ImportSessionStatus,
  MigrationSessionCreateResponse,
  ImportSessionListResponse as SessionListResponse,
  ImportSessionStatusResponse as SessionSummary,
} from '@store/generated/data-migration';

// =============================================================================
// Session Status Constants
// =============================================================================

import type { ImportSessionStatus } from '@store/generated/data-migration';

/** Statuses where we should poll for updates */
export const POLLING_STATUSES: ImportSessionStatus[] = [
  'pending',
  'processing',
  'in_progress',
  'extracting',
  'matching',
  'importing',
];

/** Statuses that require user action (stop polling) */
export const USER_ACTION_STATUSES: ImportSessionStatus[] = [
  'ready_for_review',
];

/** Terminal statuses (stop polling) */
export const TERMINAL_STATUSES: ImportSessionStatus[] = [
  'completed',
  'failed',
  'cancelled',
];

// =============================================================================
// Target Fields for Schema Mapping
// =============================================================================

export const TARGET_FIELDS = [
  'first_name',
  'last_name',
  'middle_name',
  'preferred_name',
  'dob',
  'gender',
  'sex',
  'pronouns',
  'race',
  'email',
  'mobile_phone',
  'address',
  'city',
  'state',
  'zip',
  'payer_name',
  'payer_id',
  'insurance_policy_number',
  'relationship_to_insured',
  'emergency_contact_name',
  'emergency_contact_phone',
  'emergency_contact_relationship',
  'identifier',
] as const;

export type TargetField = (typeof TARGET_FIELDS)[number];

/** Human-readable labels for target fields */
export const TARGET_FIELD_LABELS: Record<TargetField, string> = {
  first_name: 'First Name',
  last_name: 'Last Name',
  middle_name: 'Middle Name',
  preferred_name: 'Preferred Name',
  dob: 'Date of Birth',
  gender: 'Gender',
  sex: 'Sex',
  pronouns: 'Pronouns',
  race: 'Race',
  email: 'Email',
  mobile_phone: 'Mobile Phone',
  address: 'Address',
  city: 'City',
  state: 'State',
  zip: 'ZIP Code',
  payer_name: 'Insurance Payer',
  payer_id: 'Payer ID',
  insurance_policy_number: 'Policy Number',
  relationship_to_insured: 'Relationship to Insured',
  emergency_contact_name: 'Emergency Contact Name',
  emergency_contact_phone: 'Emergency Contact Phone',
  emergency_contact_relationship: 'Emergency Contact Relationship',
  identifier: 'Patient Identifier (MRN)',
};
